/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_DeclineInputs */

const en_privacy_section_4_decline = /** @type {(inputs: Privacy_Section_4_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you decline`)
};

const lv_privacy_section_4_decline = /** @type {(inputs: Privacy_Section_4_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja noraidāt`)
};

/**
* | output |
* | --- |
* | "If you decline" |
*
* @param {Privacy_Section_4_DeclineInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_decline = /** @type {((inputs?: Privacy_Section_4_DeclineInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_DeclineInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_decline(inputs)
	return en_privacy_section_4_decline(inputs)
});